// import { Toast, Tooltip } from './_bootstrap';
import './_bootstrap.js';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

(function (once, $) {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

  Drupal.behaviors.bbanlamp = {
    attach: function (context, settings) {

      once('swiper-elements', '.swiper', context).forEach(el => {
        const opts = {};
        opts.modules = [Navigation, Pagination, Autoplay];
        opts.navigation = {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        };
        opts.loop = true;
        opts.autoplay = {
          delay: 5000,
          disableOnInteraction: false,
        };

        if (el.hasAttribute('data-swiper-pagination')) {
          if (el.getAttribute('data-swiper-pagination') === 'yes') {
            opts.pagination = {
              el: ".swiper-pagination",
              clickable: true
            }
          }
        }

        const swiper = new Swiper(el, opts);
      });

      const swiperNews = new Swiper('.views-news-slider .view-content', {
        modules: [Navigation, Pagination],
        createElements: true,
        slidesPerView: 1,
        slideClass: 'views-row',
        spaceBetween: '15px',
        navigation: true,
        breakpoints: {
          540: {
            slidesPerView: 3
          }
        }
      });

      const swiperCardCarousel = new Swiper('.block--card-carousel .field--name-field-card-items', {
        modules: [Navigation, Pagination],
        createElements: true,
        slidesPerView: 1,
        navigation: true,
        slideClass: 'field__item',
        autoplay: 2500,
        spaceBetween: 10,
        breakpoints: {
          540: {
            slidesPerView: 4
          }
        }
      });

      once('countdown-tick', '.countdown-event-countdown', context).forEach(function (el) {
        const timerSeconds = setInterval(function (el) {
          const elSec = el.querySelector('.seconds .value');
          const elMin = el.querySelector('.minutes .value');
          const elHour = el.querySelector('.hours .value');

          let val = elSec.textContent;

          if (val > 0) {
            val = val - 1;
          }
          else {
            val = 59;

            // Check minutes
            let valMin = elMin.textContent;
            valMin = (valMin > 0) ? valMin - 1 : 59;
            elMin.textContent = valMin;

            // Check hours
            let valHour = elHour.textContent;
            valHour = (valHour > 0) ? valHour - 1 : 24;
            elHour.textContent = valHour;
          }

          elSec.textContent = val;
        }, 1000, el);
      })

      once('judul-submenu', '.block--judul-submenu', context).forEach(function (el) {
        const pathName = window.location.pathname;
        const links = el.querySelectorAll('.field--name-field-links .field__item');
        links.forEach(function (elem) {
          const aTag = elem.querySelector('a');
          if (aTag) {
            const aTagPath = aTag.getAttribute('href');
            if (aTagPath === pathName) {
              aTag.classList.add('current-linkmenu');
            }
          }
        });
      });

      function slideUp(element) {
        var wrapper = element;
        var items = element.querySelectorAll('.views-row');

        // Hide all items
        items.forEach(function(item) {
          // item.style.display = 'none';
        });

        // Show the first item
        // items[0].style.display = 'block';

        // Move the first item to the bottom of the wrapper
        wrapper.appendChild(items[0]);

        // Trigger reflow to apply the initial position before adding the transition class
        void items[0].offsetWidth;

        // Add the transition class for the sliding effect
        items[0].style.transition = 'transform 1s ease-in-out';

        // Slide up animation by translating the items
        items.forEach(function(item) {
          item.style.transform = 'translateY(-100%)';
        });

        // After the animation, move the item to the bottom and show the next item
        setTimeout(function() {
          items[0].style.transition = ''; // Remove the transition for the next iteration
          items[0].style.transform = '';
          wrapper.appendChild(items[0]);
          items[0].style.display = 'block';
        }, 1000); // Adjust the duration of the animation in milliseconds
      }

      once('pengumuman-slide', '.block--pengumuman .view-content', context).forEach(function (el) {

        slideUp(el);

        // Call the slideUp function every 2 seconds
        setInterval(slideUp, 7000, el);
      });

      once('news-berita-thumbnail', '.gambar-berita', context).forEach(function (el) {

        const isNewsListing = el.closest('.views-news-listing');
        const isNewsLatest = el.closest('.views-news-latest');
        const isNewsPengawasan = el.closest('.views-news-pengawasan');
        let thumbAttr = ' width="480" height="320" alt="No thumbnail" ';
        if (isNewsListing) {
          thumbAttr = ' width="340" height="210" alt="No thumbnail" ';
        }
        else if(isNewsLatest || isNewsPengawasan) {
          thumbAttr = ' width="100" height="80" alt="No thumbnail" ';
        }

        if (el.getElementsByTagName('img').length === 0) {
          el.innerHTML = '<img src="/themes/custom/bbanlamp/build/assets/images/logo-white.webp" ' + thumbAttr + ' />';
        }
      });

      // Show dropdown on hover
      if (window.innerWidth > 720) {
        $('.dropdown').mouseover(function () {
          if($('.navbar-toggler').is(':hidden')) {
            $(this).addClass('show').attr('aria-expanded', 'true');
            $(this).find('.dropdown-menu').addClass('show');
          }
        }).mouseout(function () {
          if($('.navbar-toggler').is(':hidden')) {
            $(this).removeClass('show').attr('aria-expanded', 'false');
            $(this).find('.dropdown-menu').removeClass('show');
          }
        });

        // Go to the parent link on click
        $('.dropdown > a').click(function(){
          location.href = this.href;
        });

      }
    }
  }
})(once, jQuery);
